export default angular
  .module('doxy.common.filters.firstLetters', [])
  .filter('firstLetters', function () {
    return function (text) {
      if (text) {
        text = text.toString().trim();
        return text
          .split(' ')
          .map((s) => s.trim())
          .filter((s) => !!s)
          .map((s) => s[0])
          .join('')
          .toUpperCase();
      } else {
        return '';
      }
    };
  }).name;
